type ThumbNailSizeAlias = 'atom' | 'small' | 'medium' | 'origin' | 'large';

interface Query {
  w?: number;
  f?: string;
}
const sizes: Record<ThumbNailSizeAlias, number> = {
  origin: 0,
  atom: 1,
  small: 300,
  medium: 600,
  large: 1080,
};

const regex = /^images\/(.*)\.(png|jpg|jpeg|webp|gif|svg|bmp)/i;

const makeDynamicImageUrl = function (
  url: string,
  size: ThumbNailSizeAlias,
  cdnHost: string,
  format = 'webp',
) {
  if (!url) return '';
  if (url === '/default_profile_image.webp') return `${cdnHost}${url}`;
  if (!regex.test(url)) return url;

  const [_1, filename, _2] = regex.exec(url) as RegExpExecArray;

  const query: Query = {};

  if (size !== 'origin') {
    query.w = sizes[size];
  }

  if (format !== 'webp') {
    query.f = format;
  }
  return `${cdnHost}/${filename}.webp?${objectToQuerystring(query)}`;
};

const objectToQuerystring = (query: Query) =>
  Object.entries(query)
    .map((e) => e.join('='))
    .join('&');

export const thumbnail = {
  atom: (origin: string) => {
    if (process.env.REACT_APP_DYNAMIC_IMAGE_CDN)
      return makeDynamicImageUrl(origin, 'atom', process.env.REACT_APP_DYNAMIC_IMAGE_CDN);
    return origin;
  },
  small: (origin: string) => {
    if (process.env.REACT_APP_DYNAMIC_IMAGE_CDN)
      return makeDynamicImageUrl(origin, 'small', process.env.REACT_APP_DYNAMIC_IMAGE_CDN);
    return origin;
  },
  medium: (origin: string) => {
    if (process.env.REACT_APP_DYNAMIC_IMAGE_CDN)
      return makeDynamicImageUrl(origin, 'medium', process.env.REACT_APP_DYNAMIC_IMAGE_CDN);
    return origin;
  },
  origin: (origin: string) => {
    if (process.env.REACT_APP_DYNAMIC_IMAGE_CDN)
      return makeDynamicImageUrl(origin, 'origin', process.env.REACT_APP_DYNAMIC_IMAGE_CDN);
    return origin;
  },
  resize: (origin: string, size: ThumbNailSizeAlias, format: string) => {
    if (process.env.REACT_APP_DYNAMIC_IMAGE_CDN)
      return makeDynamicImageUrl(origin, size, process.env.REACT_APP_DYNAMIC_IMAGE_CDN, format);
    return origin;
  },
};
